// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-281cd6","sapcnqr-badge--muted":"sapcnqr-badge--muted-2da378"};